import analyticsLogo from './service-icons/analyticsLogo.png';
import googleAdsLogo from './service-icons/googleAdsLogo.png';
import metaLogo from './service-icons/metaLogo.png';
import bingLogo from './service-icons/bingLogo.png';
import linkedinLogo from './service-icons/linkedinLogo.png';
import tiktokLogo from './service-icons/tiktokLogo.png';
import xLogo from './service-icons/xLogo.svg';
import nextdoorLogo from './service-icons/nextdoorLogo.svg';
import stackadaptLogo from './service-icons/stackadaptLogo.png';
import infillionLogo from './service-icons/infillionLogo.svg';
import matomoLogo from './service-icons/matomoLogo.svg';
import hubspotLogo from './service-icons/hubspotLogo.svg';
import mailchimpLogo from './service-icons/mailchimpLogo.png';
import constantContactLogo from './service-icons/constantContactLogo.svg';
import salsaLogo from './service-icons/salsaLogo.png';
import delivraLogo from './service-icons/delivraLogo.svg';
import gofundmeLogo from './service-icons/gofundmeLogo.png';
import virtuousLogo from './service-icons/virtuousLogo.png';
import blackbaudLogo from './service-icons/blackbaudLogo.png';
import klaviyoLogo from './service-icons/klaviyoLogo.png';
import acculynxLogo from './service-icons/acculynxLogo.svg';
import mediamathLogo from './service-icons/mediamathLogo.svg';
import salesforceLogo from './service-icons/salesforceLogo.svg';
import reportwerksLogo from './service-icons/reportwerksLogo.png';
import googleLogo from './service-icons/googleLogo.png';
import tagManagerLogo from './service-icons/tagManagerLogo.png';
import chatgptLogo from './service-icons/chatgpt.svg';
import mauticLogo from './service-icons/mautic.svg';

const logos = {
    'analytics': analyticsLogo,
    'chatgpt-ads': chatgptLogo,
    mautic: mauticLogo,
    google: googleLogo,
    'google-tag-manager': tagManagerLogo,
    'google-paid': googleAdsLogo,
    'google-grant': googleAdsLogo,
    'meta': metaLogo,
    'bing': bingLogo,
    'linkedin': linkedinLogo,
    'tiktok': tiktokLogo,
    'x': xLogo,
    'nextdoor': nextdoorLogo,
    'display': stackadaptLogo,
    'infillion': infillionLogo,
    'matomo': matomoLogo,
    'hubspot': hubspotLogo,
    'mailchimp': mailchimpLogo,
    'constant-contact': constantContactLogo,
    'salsa-labs': salsaLogo,
    'delivera': delivraLogo,
    'gofundmepro': gofundmeLogo,
    'virtuous': virtuousLogo,
    'sky-api': blackbaudLogo,
    'klaviyo': klaviyoLogo,
    'acculynx': acculynxLogo,
    'mediamath': mediamathLogo,
    'salesforce-marketing-cloud': salesforceLogo,
    'instant-analysis': reportwerksLogo,
};

export function getServiceLogo(service) {
    const key = String(service || '').toLowerCase().replace(/_/g, '-');
    return logos[{ stackadapt: 'display', programmatic: 'infillion', delivra: 'delivera', constantcontact: 'constant-contact', salsalabs: 'salsa-labs', 'google-analytics': 'analytics', ga4: 'analytics', 'google-ads': 'google-paid', adwords: 'google-paid', 'google-gmail': 'google', 'google-drive': 'google', skyapi: 'sky-api', 'sky-api': 'sky-api', reportwerks: 'instant-analysis', openai: 'chatgpt-ads', 'linked-in': 'linkedin' }[key] || key];
}

// Menu records may use a generic icon; the report route identifies the service.
export function getMenuService(item) {
    const route = String(item.rendererRoute || item.to || item.segment || '').replace(/^\/+|\/+$/g, '');
    const part = route.split('/').pop();
    const service = { paid: 'google-paid', grant: 'google-grant' }[part] || part;
    return getServiceLogo(service) ? service : getServiceLogo(item.key) ? item.key : item.icon;
}
